import { Button } from "@/design-system/components/ui";
import { Modal } from "@/components/ui/Modal";
import type { CertificationDefinitionDto } from "@/api/certifications";
import { formatGate } from "./gateFormat";

interface Props {
  open: boolean;
  definition: CertificationDefinitionDto | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Certifications Module v1.0 §4a — deactivate confirmation. Reactivate is
 * intentionally NOT confirmed (lower stakes — reactivation only restores
 * the item to gate evaluation; no data is mutated on existing records).
 */
export function DeactivateConfirmDialog({
  open, definition, busy, onClose, onConfirm,
}: Props) {
  if (!definition) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Deactivate certification definition?"
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} type="button" disabled={busy}>
            Cancel
          </Button>
          <Button onClick={onConfirm} loading={busy} type="button">
            Deactivate
          </Button>
        </>
      }
    >
      <p className="text-body text-onyx">
        Deactivate <strong>'{definition.label}'</strong> on {definition.entityType}{" "}
        {formatGate(definition.stageFrom, definition.stageTo)}?
      </p>
      <p className="text-small text-gray-mid mt-space-2">
        Existing certifications remain valid; the item disappears from new gate
        evaluations. You can reactivate it later.
      </p>
    </Modal>
  );
}
